import toast from "react-hot-toast";
import { CMS_LIST } from "../../store/actionTypes";
import { ENDPOINTS } from "../../utils/endPoints";
import { GET_API_CALL, PUT_API_CALL } from "../../utils/services";

/**
 * @name Actions for CMS reducer
 * @param {required data for actions} callback
 * @returns update reducers of CMS
 */

export const getCmslist = (callback) => {
  return (dispatch) => {
    GET_API_CALL(ENDPOINTS.CMS.CMS_lIST, "", (response) => {
      console.log("Response ", response);
      if (response.isSuccess) {
        callback(response?.data?.data);
        dispatch({
          type: CMS_LIST,
          payload: { ...response.data.data },
        });
      }
    });
  };
};

export const cmsUpdate = (data, params, callback) => {
  const toastId = toast.loading("Updating");
  return () => {
    PUT_API_CALL(ENDPOINTS.CMS.UPDATE_CMS + params, data, (response) => {
      console.log("Update CMS Response", response);
      if (response.isSuccess) {
        toast.success(response?.data?.message);
        callback();
      }
      toast.dismiss(toastId);
    });
  };
};

export const getCmsDetail = (id, callback) => {
  return () => {
    GET_API_CALL(ENDPOINTS.CMS.CMS_DETAILS + `?cmsId=${id}`, "", (response) => {
      console.log("CMS DETAILS RESPONSE :", response);
      if (response.isSuccess) {
        callback(response.data?.data);
      }
    });
  };
};
